(function() {
  'use strict';

  angular
    .module('webAgro1App')
    .controller('CronogramaFungicidaEditionCtrl', CronogramaFungicidaEditionController);

  CronogramaFungicidaEditionController.$inject = [
    'schedule',
    'LoadingService',
    'CronogramaFungicidasService',
    'MessagesService',
    'DATE_MASK',
    '$scope',
    'EmpreendimentosService',
    '$rootScope',
    'PlantiosService',
    'ItensService',
    'InformacoesCultivaresService'
  ];

  // eslint-disable-next-line max-params, max-lines-per-function
  function CronogramaFungicidaEditionController(schedule, LoadingService, CronogramaFungicidasService,
    MessagesService, DATE_MASK, $scope, EmpreendimentosService, $rootScope, PlantiosService,
    ItensService, InformacoesCultivaresService) {
    const vm = this;

    // Controller data
    vm.schedule = angular.copy(schedule);
    vm.formWarnings = {};
    vm.plantios = [];
    vm.infoCultivares = [];
    vm.cultivares = [];

    // Bindable methods
    vm.reloadAplicacao = reloadAplicacao;
    vm.reloadSchedule = reloadSchedule;
    vm.addAplicacao = addAplicacao;
    vm.hasNewAplicacao = hasNewAplicacao;
    vm.cancelNewAplicacao = cancelNewAplicacao;
    vm.DATE_MASK = DATE_MASK;
    vm.editScheduleData = null;
    vm.editSchedule = editSchedule;
    vm.isEditingScheduling = false;
    vm.datepickerOptions = {
      showWeeks: false
    };
    vm.setTextDatapicker = setTextDatapicker;
    vm.setCronogramaDate = setCronogramaDate;
    vm.cancelChanges = cancelChanges;
    vm.saveChanges = saveChanges;
    vm.empreendimentos = [];
    vm.onEmergenciaChange = onEmergenciaChange;
    vm.changeCultivar = changeCultivar;

    // Function declarations
    function reloadAplicacao({ id: aplicacaoId }) {
      LoadingService.showLoading();
      return CronogramaFungicidasService.loadAplicacao(aplicacaoId)
        .then((aplicacao) => {
          const index = _.findIndex(vm.schedule.parameters, { id: aplicacao.id });
          if (index > -1) {
            vm.schedule.parameters.splice(index, 1, aplicacao);
          }
        })
        .catch((error) => {
          console.error(error);
          MessagesService.alert('Não foi possível recarregar a aplicação, tente novamente');
        })
        .finally(LoadingService.hideLoading);
    }

    function setTextDatapicker(type) {
      vm.editScheduleData.datepickerTextArea[type] = moment(vm.editScheduleData[type]).format('DD/MM/YYYY');
    }

    function setCronogramaDate(type) {
      const textInputValue = (vm.editScheduleData.datepickerTextArea[type] || '').replace(/_/g, '');
      if (textInputValue.length === 10) {
        vm.editScheduleData[type] = new Date(moment(textInputValue, 'DD/MM/YYYY').format());
      } else {
        vm.editScheduleData[type] = null;
      }
    }

    // eslint-disable-next-line max-lines-per-function
    async function loadCultivares() {
      if (vm.editScheduleData) {
        try {
          if (vm.editScheduleData.editCultivar) {
            vm.editScheduleData.loading = true;
            const data = await ItensService.listCultivares({
              atividade: vm.schedule.atividade.id
            });

            vm.cultivares = data.data;

            const cultivares = vm.plantios
              .flatMap((plantio) => _.filter(vm.cultivares, { item_id: plantio.insumo_id }));

            if (cultivares.length > 0) {
              vm.cultivares = cultivares;
              vm.cultivares.push(vm.schedule.cultivar);
              vm.cultivares = _.sortBy(_.uniqBy(cultivares, 'item_id'), 'descricao');
            }

            vm.infoCultivares = await InformacoesCultivaresService.get({
              safra: (vm.schedule.safra || {}).id,
              atividade: vm.schedule.atividade.id,
              gleba: vm.schedule.gleba.id
            });

            vm.editScheduleData.loading = false;
          }
        } catch (error) {
          console.error('Erro ao listar informações de cultivares', error);
        } finally {
          vm.editScheduleData.loading = false;
          $scope.$apply();
        }
      }
    }

    async function reloadSchedule() {
      const { id } = vm.schedule;
      LoadingService.showLoading();
      return CronogramaFungicidasService.loadSchedule(id)
        .then((result) => {
          vm.schedule = result;
          loadCultivares();
        })
        .catch((error) => {
          MessagesService.alert('Não foi possível recarregar o cronograma, tente novamente.');
          console.error(error);
        })
        .finally(LoadingService.hideLoading);
    }

    function addAplicacao() {
      const newAplicacao = {
        aplicacao: null,
        data_estimada: null,
        dias_apos_aplicado: null,
        extraInfo: {
          icon: 'fa-calendar',
          border: '',
          color: '',
          title: 'Pendente'
        },
        id: null,
        items: [],
        numero_aplicacao: vm.schedule.parameters.length,
        observacoes: null,
        st_sera_realizada: 'S',
        status: 'pending'
      };
      vm.schedule.parameters.push(newAplicacao);
    }

    function hasNewAplicacao() {
      return vm.schedule.parameters.some((aplicacao) => aplicacao.id === null);
    }

    function cancelNewAplicacao() {
      vm.schedule.parameters = vm.schedule.parameters.filter((aplicacao) => aplicacao.id !== null);
    }

    function onEmergenciaChange() {
      vm.editScheduleData.colheitaEstimada = calcColheitaEstimada(vm.editScheduleData.emergencia,
        vm.editScheduleData.ciclo);
      setTextDatapicker('colheitaEstimada');
    }

    function calcColheitaEstimada(emergencia, cicloDias) {
      return !!emergencia && !!cicloDias ?
        moment(emergencia, 'dd/MM/yyyy')
          .add(cicloDias, 'days')
          .toDate() : '';
    }

    // eslint-disable-next-line max-lines-per-function
    async function editSchedule() {
      const dataEmergencia = moment(vm.schedule.data_emergencia).toDate();
      const editCultivar = !_.filter(vm.schedule.parameters, { status: 'applied' }).length;
      vm.editScheduleData = {
        ...vm.schedule,
        area: +vm.schedule.area,
        editing: true,
        editCultivar: editCultivar,
        plantio: moment(vm.schedule.data_plantio).toDate(),
        ciclo: vm.schedule.ciclo_dias,
        diasCicloAteHoje: vm.schedule.dias_do_ciclo_ate_hoje,
        emergencia: dataEmergencia,
        colheitaEstimada: vm.schedule.colheitaEstimada ?
          moment(vm.schedule.colheitaEstimada).toDate() :
          calcColheitaEstimada(dataEmergencia, vm.schedule.ciclo_dias),
        datepickerTextArea: {
          emergencia: '',
          plantio: '',
          colheitaEstimada: ''
        },
        datepickerEmergencia: {
          open: false
        },
        datepickerColheitaEstimada: {
          open: false
        }
      };
      ['emergencia', 'plantio', 'colheitaEstimada'].forEach(setTextDatapicker);
      getEmpreendimentoAtividade();
      try {
        await setGlebaAreaPlantio();
      } catch (error) {
        console.warn('Não foi possível encontrar plantios para a cultivar ', error);
      }
      loadCultivares();
    }

    function getEmpreendimentoAtividade() {
      if (vm.editScheduleData.safra && vm.editScheduleData.atividade) {
        LoadingService.showLoading();
        const filters = {
          safra: vm.editScheduleData.safra.id,
          propriedade: $rootScope.currentPropriedade.id,
          atividade: vm.editScheduleData.atividade.id
        };

        EmpreendimentosService.list(filters)
          .then(function({ data }) {
            vm.empreendimentos = data;

            CronogramaFungicidasService.setGlebaAreaEmpreendimento(vm.editScheduleData.gleba, data);
          })
          .catch(function(error) {
            MessagesService.alert('Ocorreu um erro ao buscar os empreendimentos da safra selecionada.');
            console.error(error);
          })
          .finally(LoadingService.hideLoading);
      }
    }


    function setGlebaAreaPlantio() {
      vm.plantioDates = null;
      return PlantiosService.getPlantioSimples({
        onlyActive: true,
        safra: vm.editScheduleData.safra.id,
        atividade: vm.editScheduleData.atividade.id,
        gleba: vm.editScheduleData.gleba.id
      }).then(({ data: plantios }) => {
        vm.plantios = plantios;
        vm.editScheduleData.gleba.areaPlantio = _.sumBy(plantios, (plantio) => parseFloat(plantio.area));
      });
    }


    function changeCultivar() {
      const plantio = _.find(vm.plantios, { insumo_id: (vm.editScheduleData.cultivar || {}).item_id });
      if ((plantio || {}).data_fim) {
        vm.editScheduleData.plantio = moment(plantio.data_fim).toDate();
        vm.editScheduleData.area = parseFloat(plantio.area);
        vm.editScheduleData.gleba.areaPlantio = parseFloat(plantio.area);
      } else {
        vm.editScheduleData.plantio = null;
      }

      const informacao = _.find(vm.infoCultivares, { cd_insumo: vm.editScheduleData.cultivar.item_id });

      if (informacao) {
        vm.editScheduleData.ciclo = informacao.ciclo_dias || 0;
        vm.editScheduleData.emergencia = moment(informacao.data_emergencia).toDate();
        vm.editScheduleData.colheitaEstimada = informacao.data_estimada_colheita;

        calcColheitaEstimada(vm.editScheduleData.emergencia, vm.editScheduleData.ciclo);
      } else {
        vm.editScheduleData.ciclo = 0;
        vm.editScheduleData.emergencia = null;
        vm.editScheduleData.colheitaEstimada = null;
      }

      ['emergencia', 'plantio', 'colheitaEstimada'].forEach(setTextDatapicker);
    }

    function cancelChanges() {
      vm.editScheduleData = null;
    }

    function saveChanges() {
      LoadingService.showLoading();

      const { id } = vm.schedule;

      CronogramaFungicidasService.updateSchedule(id, vm.editScheduleData)
        .then(() => {
          reloadSchedule();
          vm.editScheduleData = null;
        })
        .catch((error) => {
          MessagesService.alert('Não foi possível atualizar o cronograma, tente novamente.');
          console.error(error);
        })
        .finally(LoadingService.hideLoading);
    }

    $scope.$watch(
      '$ctrl.editScheduleData',
      (newValue) => vm.formWarnings = CronogramaFungicidasService.checkFormWarnings(newValue),
      _.isEqual
    );
  }
}());
